import { RootState } from "../store"

export const chatSelector = (state: RootState) => state.chat
